<template>
  <v-menu
    class="select-with-groups"
    v-model="isOpened"
    :close-on-content-click="false"
    offset-y
  >
    <template v-slot:activator="{ on, attrs }">
      <v-card
        class="pa-3 select-with-groups__content v-input"
        v-bind="attrs"
        v-on="on"
      >
        <v-container
          fluid
          class="ma-0 pa-0"
        >
          <v-row class="ma-0 pa-0">
            <v-col class="ma-0 pa-0">
              <template v-if="selectedValue && selectedValue.length">
                <template v-for="(item, index) in selectedValue">
                  {{ item }}<template v-if="index !== (selectedValue.length - 1)">
                    ,
                  </template>
                </template>
              </template>
              <span
                class="select-with-groups__empty-label theme--light v-label"
                v-else
              >
                {{ label }}
              </span>
            </v-col>
            <v-col
              class="ma-0 pa-0 text-right"
              cols="1"
            >
              <v-icon
                v-if="selectedValue && selectedValue.length"
                class="mr-2"
                color="grey"
                @click.stop.prevent="handleClearAllClick"
              >
                close
              </v-icon>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </template>
    <v-card :height="selectWidth">
      <v-list v-model="openedGroup">
        <v-list-group
          v-for="item in options"
          :key="item.title"
          prepend-icon="add"
          append-icon=""
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title v-text="item.title" />
            </v-list-item-content>
          </template>

          <v-list-item
            v-for="(subItem, index) in item.items"
            class="pa-0 px-3"
            :key="index"
            :ripple="!isOptionDisabled(subItem)"
          >
            <v-checkbox
              class="my-2 py-0 select-with-groups__checkbox"
              v-model="selectedValue"
              :value="subItem"
              :disabled="isOptionDisabled(subItem)"
              hide-details
              multiple
              @change="handleSelectChange"
              @click="handleCheckboxClick(subItem)"
            >
              <template v-slot:label>
                <div :class="['subtitle-1', isOptionDisabled(subItem) ? 'text--grey' : 'text--primary']">
                  {{ subItem }}
                </div>
              </template>
            </v-checkbox>
          </v-list-item>
        </v-list-group>
      </v-list>
    </v-card>
  </v-menu>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import { IOption } from '@/types/form'
import { waitAsync } from '@/utils/common'
import { IRole } from '@/types/dictionaries'

interface IOptionItem {
  title: string
  items: IOption[]|string[]|number[]
}

@Component
export default class SelectWithGroupedOptions extends Vue {
  @Prop({ required: true, default: 'SelectWithGroupedOptions' }) id: string
  @Prop({ required: true, default: '' }) label: string
  @Prop({ required: true, default: [] }) options: IOptionItem[]
  @Prop({ default: false }) disabled: boolean
  @Prop() value: any
  @Prop({ default: false }) multi: boolean
  @Prop({ default: 350 }) selectWidth: number

  isOpened: boolean = false
  openedGroup: any = null

  get selectedValue () {
    return this.value
  }

  set selectedValue (value) {
    this.$emit('update:value', value)
  }

  isOptionSelected (value: any): boolean {
    return this.selectedValue.includes(value)
  }

  isOptionDisabled (value: any): boolean {
    return !this.isOptionSelected(value) && this.disabled
  }

  async handleSelectChange (value: any) {
    this.$emit('selectChange', value)
  }

  handleClearAllClick () {
    this.$emit('clearAll')
  }

  async handleCheckboxClick (value: IRole) {
    await waitAsync(100)
    const isCheckboxChecked = !!this.selectedValue.find((item: string) => item === value)
    if (isCheckboxChecked) this.$emit('checkOption', value)
  }
}
</script>
<style lang="scss" scoped>
.select-with-groups {
  font-size: 1.25rem;
}
.no-ellipsis {
  white-space: normal;
  text-overflow: initial;
}
.select-with-groups__checkbox {
  width: 100%;
}
::v-deep .v-list-item--active:before,
.v-list-item--active::before {
  opacity: 0.12 !important;
}
</style>
